/**
 * Created by andrey on 03.06.2025
 */

const Merge2UnitsShopCartRibbon = cc.Node.extend({
    ctor: function (cart) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);

        this.cart = cart;
        this.addChild(cart);

        const styles = cleverapps.styles.Merge2UnitsShopCartRibbon;

        const background = this.background = cleverapps.UI.createScale9Sprite(bundles.tile_shop.frames.cart_ribbon_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize(styles.width, background.height);
        background.setLocalZOrder(-1);
        this.addChild(background);

        this.setContentSize(background.getContentSize());
        background.setAlignment({ align: "center" }, { align: "center" });

        this.setTransient(false);
        this.setAlignment(styles);
    },

    fitToAvailableRect: function (availableRect) {
        this.stopAllActions();

        const styles = cleverapps.styles.Merge2UnitsShopCartRibbon;
        this.setTransient(false);
        this.setAlignment(styles);

        this.x = Math.min(this.x, availableRect.x + availableRect.width - this.width / 2);

        this.showPosition = this.getPosition();
        this.hidePosition = cc.p(this.x - this.width, this.y);

        if (cleverapps.resolution.isVertical() || this.x < 0) {
            this.setTransient(true);
            this.setAlignment(styles.transient);
            this.hide(true);

            this.hidePosition = this.getPosition();
            this.showPosition = cc.p(this.x + styles.transient.show.dx, this.y);
        }
    },

    setTransient: function (transient) {
        this.cart.setTransient(transient);

        this.transient = transient;
    },

    toggle: function (visible, silent) {
        if (visible) {
            this.show(silent);
        } else {
            this.hide(silent);
        }
    },

    showUp: function () {
        if (this.transient) {
            return;
        }

        this.stopAllActions();

        this.setPosition(this.hidePosition);
        this.setScale(1.05, 0.95);

        this.runAction(new cc.Sequence(new cc.Spawn(
            new cc.MoveTo(0.45, this.showPosition).easing(cc.easeBackOut()),
            new cc.Sequence(
                new cc.DelayTime(0.25),
                new cc.ScaleTo(0.2, 1, 1)
            )
        )));

        this.cart.showUp();
    },

    show: function (silent) {
        if (this.isShown || !this.transient) {
            return;
        }

        this.isShown = true;

        this.stopAllActions();

        this.cart.showAnimation(silent);

        this.setVisible(true);

        if (silent) {
            this.setPosition(this.showPosition);
            this.setScale(1);
            return;
        }

        this.runAction(new cc.Sequence(new cc.Spawn(
            new cc.MoveTo(0.45, this.showPosition).easing(cc.easeBackOut()),
            new cc.Sequence(
                new cc.DelayTime(0.25),
                new cc.ScaleTo(0.2, 1, 1)
            )
        )));
    },

    hide: function (silent) {
        if (!this.isShown || !this.transient) {
            return;
        }

        this.isShown = false;

        this.stopAllActions();

        this.cart.hideAnimation(silent);

        if (silent) {
            this.setPosition(this.hidePosition);
            this.setScale(1.2, 0.8);
            this.setVisible(false);
            return;
        }

        this.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.MoveTo(0.45, this.hidePosition).easing(cc.easeBackIn()),
                new cc.Sequence(
                    new cc.ScaleTo(0.25, 1.2, 0.8),
                    new cc.DelayTime(0.2)
                )
            ),
            new cc.Hide()
        ));
    },

    beforeCloseAnimation: function () {
        if (this.transient && !this.isShown) {
            this.background.setVisible(false);
            this.show(true);
        }

        this.cart.setTransient(false);
        this.cart.showAnimation(true);

        cleverapps.persist.sendNode(this.cart, "UnitsShopCart");
    }
});

cleverapps.styles.Merge2UnitsShopCartRibbon = {
    width: 500,

    x: { align: "left", dx: -80 },
    y: { align: "center" },

    transient: {
        x: { align: "left", dx: -500 },
        y: { align: "center", dy: 300 },

        show: { dx: 240 }
    }
};